import { Box, Rhythm } from '@trmediaab/zebra';

import Ad from '~/components/Ad';

import FrontpageAuthorList from './FrontpageAuthorList';
import RoundList from './RoundList';

export default function FrontpageSidebar() {
  return (
    <Rhythm between={3} display={{ _: 'none', xl: 'block' }}>
      <RoundList />
      <FrontpageAuthorList />
      <Box pt="4">
        <Ad deviceFilter="desktopOnly" placement="sticky" />
      </Box>
    </Rhythm>
  );
}
